import { query_shift_name_list } from 'liyu-pc-base/api/org-model';

export default () => {
  const search_config: any = {
    model: {
      is_active: true,
      is_type: 10,
      is_me: true,
    },
    watch: [],
  };
  return {
    getData: query_shift_name_list,
    searchConfig: search_config,
  };
};
